import { isString } from 'min-dash';

import { formatFormFieldReport } from './ProblemsReporter.js';

import { get } from 'min-dash';

export function textToLabel(text = '...') {
  if (text.length > 30) {
    return `${text.substring(0, 27)}...`;
  }

  return text;
}

export function capitalize(string) {
  return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
}

export function executeRecursively(execute, node, context) {
  if (execute(node, context)) {
    if (Array.isArray(node.components)) {
      node.components.forEach(childNode => executeRecursively(execute, childNode, context));
    }
  }
}

export function isExpression(value) {
  return isString(value) && value.startsWith('=');
}

export function isTemplate(value) {
  return !isExpression(value) && /{{/.test(value);
}

export function reportExpression(node, path, label, context) {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if (isExpression(get(node, path))) {
    const errorMessage = `${label} populated by an expression is not supported by ${executionPlatformLabel}`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;
}

export function reportTemplate(node, path, label, context) {

  const {
    executionPlatformLabel,
    reporter,
    category
  } = context;

  if (isTemplate(get(node, path))) {
    const errorMessage = `${label} populated by a template is not supported by ${executionPlatformLabel}`;
    reporter.report(formatFormFieldReport(node, errorMessage, category));
  }

  return true;

}

export function getIndefiniteArticle(type, uppercase = true) {

  const capitalizedFirstWord = capitalize(type.split(' ')[ 0 ]);

  if ([ 'Image' ].includes(capitalizedFirstWord)) {
    return uppercase ? 'An' : 'an';
  }

  return uppercase ? 'A' : 'a';
}
